<div id="main-container">
  <router-outlet></router-outlet>
  <notifier-container></notifier-container>
</div>
